var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.logout()}}},[_c('span',{staticClass:"no-icon"},[_vm._v("Log out")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }